import appConfig from '@/config/appConfig.typed';
import {filterSectionsById} from '@/services/pageSectionService';
import arrayUtils from '@/utils/arrayUtils';
import {findHighlightIndexByTag, mergeHighlightsFromCarousels} from '@/views/Highlights/utils/highlightsUtils';

export const getHighlights = (id) => {
    const carouselsFromConfig = appConfig.getHighlightsDesktop();
    const isAutoPlayEnabled = appConfig.getHighlightsDesktopAutoplay();

    const sortHighlightsInCarousel = ({highlights, ...rest}) => {
        const byHighlightOrder = ({banner: a}, {banner: b}) => a?.order - b?.order;

        const filteredHighlights = filterSectionsById({list: highlights, id});
        const sortedHighlights = filteredHighlights?.sort(byHighlightOrder);

        if (!sortedHighlights?.length) return;

        const carousel = {
            ...rest,
            highlights: sortedHighlights,
        };

        return carousel;
    };

    const byCardOrder = ({order: a}, {order: b}) => a - b;

    const sortedCarouselsFromConfig = arrayUtils.filterEmptyObjects(
        carouselsFromConfig?.map(sortHighlightsInCarousel)?.sort(byCardOrder)
    );

    return {
        carouselsFromConfig: sortedCarouselsFromConfig || [],
        isAutoPlayEnabled,
    };
};

export const findHighlightIndexByTagInCarousels = (carouselsFromConfig, visibleCount, tag) => {
    const mergedHighlights = mergeHighlightsFromCarousels(carouselsFromConfig, visibleCount);

    return findHighlightIndexByTag(mergedHighlights, tag);
};

export const findCarouselAndSlideByTag = (carouselsFromConfig, visibleCount, tag) => {
    if (!tag || !carouselsFromConfig?.length) {
        return {carouselIndex: -1, slideIndex: -1, globalIndex: -1};
    }

    const visibleCarousels = carouselsFromConfig.slice(0, visibleCount);
    let globalIndex = 0;

    for (let carouselIndex = 0; carouselIndex < visibleCarousels.length; carouselIndex++) {
        const carousel = visibleCarousels[carouselIndex];
        const highlights = carousel.highlights || [];

        const slideIndex = highlights.findIndex((highlight) => highlight?.tag?.toLowerCase() === tag.toLowerCase());

        if (slideIndex !== -1) {
            return {
                carouselIndex,
                slideIndex,
                globalIndex: globalIndex + slideIndex,
            };
        }

        globalIndex += highlights.length;
    }

    return {carouselIndex: -1, slideIndex: -1, globalIndex: -1};
};
